import React from "react";
import Flatpickr from "react-flatpickr";
import { Button, Input, Label, Spinner } from "reactstrap";
import type { SucursalSistemaOption } from "./MonchisAutoConciliacion.helpers";

type AutoConciliacionFiltersProps = {
  rangoFechas: Date[];
  onRangoCambio: (dates: Date[]) => void;
  sucursalFiltro: string;
  sucursalOpciones: SucursalSistemaOption[];
  onSucursalCambio: (valor: string) => void;
  onBuscar: () => void;
  onGuardar: () => void;
  onDescargar: () => void;
  autoCargando: boolean;
  autoConciliando: boolean;
  autoExportando: boolean;
  puedeGuardar: boolean;
  controlesDeshabilitados?: boolean;
};

const MonchisAutoConciliacionFilters: React.FC<AutoConciliacionFiltersProps> = ({
  rangoFechas,
  onRangoCambio,
  sucursalFiltro,
  sucursalOpciones,
  onSucursalCambio,
  onBuscar,
  onGuardar,
  onDescargar,
  autoCargando,
  autoConciliando,
  autoExportando,
  puedeGuardar,
  controlesDeshabilitados = false,
}) => (
  <div className="border rounded p-3 mb-4">
    <div className="d-flex flex-column flex-lg-row align-items-stretch gap-3">
      <div className="flex-fill" style={{ minWidth: 220 }}>
        <Label className="form-label text-muted">Rango de fechas</Label>
        <Flatpickr
          className="form-control"
          value={rangoFechas}
          options={{ mode: "range", dateFormat: "Y-m-d" }}
          onChange={onRangoCambio}
          disabled={controlesDeshabilitados || autoConciliando}
        />
      </div>
      <div className="flex-fill" style={{ minWidth: 220 }}>
        <Label className="form-label text-muted">Sucursal</Label>
        <Input
          type="select"
          value={sucursalFiltro}
          onChange={(e) => onSucursalCambio(e.target.value)}
          disabled={controlesDeshabilitados || autoConciliando}
        >
          <option value="">Todas</option>
          {sucursalOpciones.map((sucursal) => (
            <option key={sucursal.idsucursal} value={sucursal.idsucursal}>
              {sucursal.sucursalNombre}
            </option>
          ))}
        </Input>
      </div>
      <div className="flex-fill" style={{ minWidth: 260 }}>
        <Label className="form-label text-muted">Acciones</Label>
        <div className="d-flex flex-wrap flex-lg-nowrap gap-2">
          <Button
            color="primary"
            className="flex-fill"
            onClick={onBuscar}
            disabled={autoCargando || controlesDeshabilitados || autoConciliando}
          >
            {autoCargando ? (
              <>
                <Spinner size="sm" className="me-2" /> Procesando…
              </>
            ) : (
              <>
                <i className="ri-search-line me-2" />
                Buscar
              </>
            )}
          </Button>
          <Button
            color="success"
            className="flex-fill"
            disabled={!puedeGuardar || autoConciliando}
            onClick={onGuardar}
          >
            {autoConciliando ? (
              <>
                <Spinner size="sm" className="me-2" /> Guardando…
              </>
            ) : (
              <>
                <i className="ri-magic-line me-2" />
                Guardar coincidencias
              </>
            )}
          </Button>
          <Button
            color="secondary"
            outline
            className="flex-fill"
            onClick={onDescargar}
            disabled={autoExportando || controlesDeshabilitados || autoConciliando}
          >
            {autoExportando ? (
              <>
                <Spinner size="sm" className="me-2" /> Generando…
              </>
            ) : (
              <>
                <i className="ri-download-line me-2" />
                Descargar Excel
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default MonchisAutoConciliacionFilters;
